module.exports = __webpack_public_path__ + "static/necklace_of_fireballs-8c0858048e78c365a808b6810b0826dc.jpeg";